// src/data.js — single source of truth. Edit here, not in components.

export const KPIS = [
  {
    k: "experience",
    v: "5+",
    unit: "yrs",
    sub: ["backend & cloud-native"],
  },
  {
    k: "cloud certs",
    v: "5",
    unit: "",
    sub: [{ ac: "AWS SAA" }, " · KCNA · CCP · ACA · DevOps"],
  },
  {
    k: "hackathon",
    v: "2nd",
    unit: "place",
    sub: ["GPT-5 Co-creating · ", { ac: "EchoJournal" }],
  },
];

export const STACK = [
  {
    cat: "Languages",
    ns: "λ.lang",
    items: [
      { n: "TypeScript", yr: 4, tier: "pri" },
      { n: "Python", yr: 5, tier: "pri" },
      { n: "Go", yr: 3, tier: "pri" },
      { n: "JavaScript", yr: 5, tier: "pri" },
      { n: "Shell", yr: 4, tier: "sec" },
    ],
  },
  {
    cat: "Frameworks",
    ns: "svc.framework",
    items: [
      { n: "NestJS", yr: 3, tier: "pri" },
      { n: "Django", yr: 3, tier: "pri" },
      { n: "Express", yr: 4, tier: "pri" },
      { n: "Gin", yr: 2, tier: "sec" },
      { n: "React", yr: 4, tier: "pri" },
      { n: "Vue 3", yr: 1, tier: "sec" },
    ],
  },
  {
    cat: "Cloud & Infrastructure",
    ns: "infra.platform",
    items: [
      { n: "AWS", yr: 4, tier: "pri" },
      { n: "Terraform", yr: 3, tier: "pri" },
      { n: "Kubernetes", yr: 3, tier: "pri" },
      { n: "ArgoCD", yr: 2, tier: "sec" },
      { n: "GitHub Actions", yr: 4, tier: "pri" },
      { n: "Bitbucket Pipelines", yr: 2, tier: "sec" },
    ],
  },
  {
    cat: "Databases",
    ns: "data.store",
    items: [
      { n: "PostgreSQL", yr: 5, tier: "pri" },
      { n: "MongoDB", yr: 4, tier: "pri" },
      { n: "Redis", yr: 3, tier: "pri" },
    ],
  },
  {
    cat: "Observability",
    ns: "ops.observe",
    items: [
      { n: "Prometheus", yr: 2, tier: "pri" },
      { n: "Grafana", yr: 2, tier: "pri" },
    ],
  },
  {
    cat: "Specialties",
    ns: "focus.areas",
    items: [
      { n: "Distributed systems", yr: 4, tier: "pri" },
      { n: "CI/CD automation", yr: 4, tier: "pri" },
      { n: "API design", yr: 5, tier: "pri" },
      { n: "Observability", yr: 3, tier: "sec" },
      { n: "Accessibility", yr: 3, tier: "sec" },
      { n: "Software testing", yr: 4, tier: "pri" },
    ],
  },
];

export const TIMELINE = [
  {
    now: true,
    when: { y: "Sep 2023", m: "→ now" },
    hash: "a3f9c2d",
    branch: "main",
    title: "Software Engineer",
    org: "Kitrel LLC",
    bullets: [
      "Architect and develop scalable backend services in TypeScript + NestJS on AWS — modular design, maintainable code, type-safe data models.",
      "Lead design and code reviews; enforce performance, testing and style standards across the team.",
      "Built GitOps CI/CD on Bitbucket Pipelines, GitHub Actions and ArgoCD — cut release time by 40% and improved deploy reliability.",
      "Optimise AWS infra for performance, cost and HA using Terraform and the AWS SDK; observability via Prometheus + Grafana.",
      "Integrate PostgreSQL and MongoDB into a single type-safe data layer; collaborate with designers on accessible, high-performing products.",
    ],
    refs: [
      "typescript",
      "nestjs",
      "aws",
      "terraform",
      "argocd",
      "postgres",
      "mongodb",
    ],
  },
  {
    when: { y: "May 2023", m: "Jul 2023" },
    hash: "7b1d4e8",
    branch: "feat/health-portal",
    title: "Software Engineer",
    org: "Badili Innovations",
    bullets: [
      "Designed and built a multilingual disease-manual portal in React + Django; full i18n for Swahili and English.",
      "Built and tested APIs powering web, mobile and ML-model integrations — accessible, robust, well-typed data exchange.",
      "Shipped a rich-text editing experience that materially improved content management for healthcare authors.",
    ],
    refs: ["react", "django", "i18n", "rest", "ml"],
  },
  {
    when: { y: "Oct 2022", m: "Apr 2023" },
    hash: "12fa66c",
    branch: "release/mobile",
    title: "Software Engineer",
    org: "Stax",
    bullets: [
      "Ran automated and manual test cycles for mobile releases — caught usability and security regressions before shipping.",
      "Partnered with QA and engineering to track and resolve defects; improved release stability by ~30%.",
      "Designed testing workflows that raised regression-catch rate and tightened data validation during build cycles.",
    ],
    refs: ["mobile", "qa", "automation", "security"],
  },
  {
    when: { y: "Jun 2021", m: "Feb 2022" },
    hash: "3e0a91b",
    branch: "feat/mentor",
    title: "Technical Mentor",
    org: "Andela · ALC with Google",
    bullets: [
      "Mentored 100+ learners through full-stack development with Angular, Node.js and REST APIs.",
      "Emphasised clean architecture, algorithmic thinking and production-ready habits.",
      "Provided code review, debugging and performance-optimisation support — helped many cohort members reach industry readiness.",
    ],
    refs: ["angular", "node", "rest", "mentorship"],
  },
  {
    when: { y: "Jun 2019", m: "Sep 2019" },
    hash: "0c8a44e",
    branch: "feat/intern",
    title: "Intern",
    org: "National Treasury & Planning",
    bullets: [
      "Collected, analysed and presented data to support national policy priorities.",
      "Researched academic literature and contributed to budget formulation, strategic planning and performance evaluation.",
    ],
    refs: ["data", "policy", "research"],
  },
];

export const EDUCATION = [
  {
    kind: "BSc",
    title: "BSc. Mathematics",
    org: "Technical University of Kenya",
    when: "",
  },
  {
    kind: "NANO",
    title: "Cloud DevOps Nanodegree",
    org: "Udacity",
    when: "Nov 2022 — Mar 2023",
  },
  {
    kind: "TRACK",
    title: "ALX Software Engineering Track",
    org: "ALX",
    when: "Feb 2022 — Mar 2023",
  },
  {
    kind: "SCHOL",
    title: "Google Africa Developer Scholarship (Web Dev)",
    org: "Google",
    when: "Jun 2021 — Feb 2022",
  },
];

export const CERTS = [
  {
    id: "AWS-SAA",
    title: "AWS Certified Solutions Architect",
    tier: "pri",
    url: "https://www.credly.com/badges/9ca096a1-2873-4019-813a-92f2ac6b845d/public_url",
  },
  {
    id: "KCNA",
    title: "Kubernetes and Cloud Native Associate",
    tier: "pri",
    url: "https://www.credly.com/badges/e0a45f8c-64c9-45f3-b328-209b26bbae3c/public_url",
  },
  {
    id: "AWS-CCP",
    title: "AWS Certified Cloud Practitioner",
    tier: "sec",
    url: "https://www.credly.com/badges/4016caf1-6656-46b2-96b6-37083d31f921/public_url",
  },
  {
    id: "AWS-ACA",
    title: "AWS Cloud Architecting",
    tier: "sec",
    url: "https://www.credly.com/badges/465f5a48-f883-4e01-a320-c0ea9fa7dc81/linked_in_profile",
  },
  {
    id: "CDE",
    title: "Cloud DevOps Engineer",
    tier: "sec",
    url: "https://www.udacity.com/certificate/PSH9YKKQ",
  },
];

export const FEATURED = {
  nm: "echojournal",
  team: "ctrlaltelite",
  v: "🥈 2nd Place · Co-creating with GPT-5 Hackathon 2025",
  tagline: "Guided multimodal AI journaling",
  desc: "A multimodal journaling web app that guides users through reflective writing with GPT-5. Voice + text input, real-time sync, Google OAuth, and an accessibility-first UI (AA contrast + ARIA). Built in 48 hours with team ctrlaltelite — placed second worldwide.",
  tags: [
    "vue3",
    "typescript",
    "nestjs",
    "postgres",
    "gpt-5",
    "google-auth",
    "a11y",
  ],
  metrics: [
    { v: "2nd", l: "global rank" },
    { v: "48h", l: "build window" },
    { v: "AA", l: "a11y target" },
    { v: "OAuth", l: "google auth" },
  ],
  url: "https://lablab.ai/ai-hackathons/co-creating-with-gpt-5/ctrlaltelite/echojournal-guided-multimodal-ai-journaling",
};

export const SYSTEMS = [
  {
    nm: "brysonwaisi/automate-deployment-with-argocd",
    v: "main · 9 commits",
    badge: { t: "GITOPS", w: false },
    desc: "Production-grade GitOps pipeline. Provisions an EKS cluster with Terraform, deploys workloads via ArgoCD using the App-of-Apps pattern, and manages secrets with Sealed Secrets. Helm-charted services pulled from ECR.",
    tags: [
      "terraform",
      "eks",
      "argocd",
      "helm",
      "ecr",
      "sealed-secrets",
      "app-of-apps",
    ],
    metrics: [
      { v: "EKS", l: "cluster" },
      { v: "App-of-Apps", l: "pattern" },
      { v: "94%", l: "HCL / IaC" },
    ],
    url: "https://github.com/brysonwaisi/automate-deployment-with-argocd",
  },
  {
    nm: "brysonwaisi/kubernetes-repo",
    v: "main · 21 commits",
    badge: { t: "MANIFESTS", w: false },
    desc: "The Kubernetes manifest repo that pairs with the ArgoCD pipeline above. Helm charts per microservice, dev/prod environment overlays, plus a Python GitOps automation script for managing rollouts.",
    tags: ["helm", "kubernetes", "python", "gitops", "argocd"],
    metrics: [
      { v: "multi-env", l: "dev / prod" },
      { v: "Helm", l: "templating" },
      { v: "auto", l: "rollouts" },
    ],
    url: "https://github.com/brysonwaisi/kubernetes-repo",
  },
  {
    nm: "brysonwaisi/Operationalize-a-Machine-Learning-Microservice-API",
    v: "udacity capstone",
    badge: { t: "ML + K8S", w: false },
    desc: "Cloud DevOps Nanodegree capstone — containerises a Python Flask ML microservice (sklearn housing-price predictor), runs it on Kubernetes, with CircleCI for lint + build + deploy. Operationalises a model end-to-end.",
    tags: ["python", "flask", "sklearn", "docker", "kubernetes", "circleci"],
    metrics: [
      { v: "Flask", l: "ml service" },
      { v: "K8s", l: "runtime" },
      { v: "CI", l: "lint+deploy" },
    ],
    url: "https://github.com/brysonwaisi/Operationalize-a-Machine-Learning-Microservice-API",
  },
  {
    nm: "brysonwaisi/kubernetes-the-hard-way",
    v: "self-study",
    badge: { t: "DEEP DIVE", w: true },
    desc: "Walked Kelsey Hightower's reference path end-to-end — bootstrapping a Kubernetes cluster from scratch on GCE. Control plane, etcd quorum, CNI, kubelets, TLS bootstrap. No scripts, no shortcuts.",
    tags: ["kubernetes", "gcp", "etcd", "shell", "tls"],
    metrics: [
      { v: "control", l: "plane built" },
      { v: "etcd", l: "quorum" },
      { v: "0", l: "scripts used" },
    ],
    url: "https://github.com/brysonwaisi/kubernetes-the-hard-way",
  },
];

export const QUOTES = [
  {
    body: "Bryson is the engineer you assign to the problem when you'd rather not assign it. He thinks in invariants, not symptoms, and writes code that makes the next person's job easier.",
    nm: "Bobby Orgun",
    ro: "Engineering peer · collaborator",
    in: "BO",
  },
  {
    body: "Impressive attention to detail. He catches the nitty-gritty things in code review and in production — the kind of stuff that quietly bites you six months later.",
    nm: "Francis Issacs",
    ro: "Software Engineer · collaborator",
    in: "FI",
  },
  {
    body: "Strong debugging and backend instincts. The APIs he ships are the ones I trust to actually scale when traffic shows up.",
    nm: "Ochieng Obuku",
    ro: "Backend Engineer · collaborator",
    in: "OO",
  },
  {
    body: "Great communicator. Calm in incidents, sharp in review, and the rare engineer who'll happily pair on the unglamorous parts.",
    nm: "Bruce Tilla",
    ro: "Software Engineer · collaborator",
    in: "BT",
  },
];
